import { Button, Logo, StartupLink } from "../../atoms"
import { MessageCard } from "../../molecules/MessageCard"
import logo from "../../../assets/logo.svg"
import { useNavigate } from "react-router-dom"
import { useContext } from "react"
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext"
import { postDenyMatch } from "api/Api"
import { Match, ModalType } from "components/types/types"
import useMediaQuery from "hook/useMediaQuery"
import { MediaTablet } from "api/const/MediaQuery"
import { LoginType } from "components/types/Context"


type AskMatchProps = {
  name: string,
  fromSender: boolean,
  fromStartup: boolean,
  StartupID: string,
  logoImg: string
  match: Match
  isOld: boolean
}

export const AskMatchMessage = ({ name, fromSender, StartupID, logoImg, match, fromStartup, isOld }: AskMatchProps) => {
  const navigate = useNavigate()
  const {
    setModalDatesIsOpen,
    loginType,
    setChatIsOpen,
    setstartUpIdforMatch,
    setMatchSelected,
    setErrorModal
  } = useContext(AppGeneralContext)
  const tablet = useMediaQuery(MediaTablet)

  const Match = (startupID: string, matchId: string) => {
    if (isOld) {
      return
    }
    setstartUpIdforMatch(startupID);
    setMatchSelected(match);
    setModalDatesIsOpen(true)
  }
  const showProfile = () => {
    if (isOld) {
      return
    }
    return navigate(`/corporate/startup-profile/${StartupID}`)
  }

  const Deny = () => {
    if (isOld) {
      return
    }

    return postDenyMatch({ matchId: match.id }).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return false
      }
      const route = loginType === LoginType.startup ? "start-up" : "corporate"
      return tablet ? navigate(`${route}//profile/messaging`) : setChatIsOpen(false)
    })
  }

  return (
    <MessageCard className=" " fromSender={fromSender}>
      {fromSender ?
        <p className="m-0 p-0"> You ask for a match.</p>
        :
        <p className="m-0 p-0"> {name} wants to get in touch with you. Look at his profile.</p>
      }
      <StartupLink name={name} id={StartupID} logoUrl={logoImg} />
      {(!fromSender) &&
        <div className="w-100 d-flex flex-column align-items-center ">
          <Button disabled={isOld} primary background={"transparent"} borderColor={"white"} color={"white"} text={'DECLINE'} className='w-100 mb-2'
            onClick={() => { Deny() }} />
          <Button disabled={isOld} primary background={"transparent"} borderColor={"white"} color={"white"} text={'VIEW PROFILE'} className='w-100 mb-2'
            onClick={() => showProfile()} />
          <Button disabled={isOld} primary background={"white"} borderColor={"white"} color={"Black"} text={'MATCH'} className='w-100 fw-700 '
            icon={logo} removeRotate onClick={() => Match(StartupID, match.id)} />
        </div>
      }
    </MessageCard>
  )
}